<!--
 * @Author: LiuChuanQi
 * @Date: 2022-11-30 14:32:53
 * @LastEditTime: 2023-01-03 11:14:31
 * @LastEditors: LiuChuanQi
 * @Description:
 * @FilePath: \speedtest-bigdata-v2\src\components\common\login\FirstLogin.vue
 *
-->
<template>
  <div class="register-content">
    <div class="title">登录成功</div>
    <div class="top-tip">该帐号第一次登录注册，请完善个人信息</div>
    <div class="input-content">
      <div class="input-item">
        <input
          type="text"
          placeholder="设置用户名，5-20字符"
          class="account"
          :class="{'error':nameErrorInfor}"
          v-model="submitInfor.name"
          @blur="blurEvent('name')"
          v-input
        >
        <div class="bottom-tip">{{nameErrorInfor}}</div>
      </div>
      <div class="input-item">
        <input
          type="text"
          placeholder="设置邮箱"
          class="account"
          :class="{'error':emailErrorInfor}"
          v-model="submitInfor.email"
          @blur="blurEvent('email')"
          v-input
        >
        <div class="bottom-tip">{{emailErrorInfor}}</div>
      </div>
      <div class="input-item">
        <input
          type="password"
          placeholder="设置密码"
          class="account"
          :class="{'error':passwordErrorInfor}"
          v-model="submitInfor.password"
          @blur="blurEvent('password')"
          @paste="pastePassword"
        >
        <div class="bottom-tip">{{passwordErrorInfor}}</div>
      </div>
      <div class="input-item">
        <input
          type="password"
          placeholder="确认密码"
          class="account"
          :class="{'error':rePasswordErrorInfor}"
          v-model="submitInfor.rePassword"
          @blur="blurEvent('rePassword')"
          @paste="pasteRePassword"
        >
        <div class="bottom-tip">{{rePasswordErrorInfor}}</div>
      </div>
    </div>
    <div
      class="login"
      @click.stop="toLogin"
    >确定</div>
  </div>
</template>

<script>
import store from '@/store/index'
import { verifyMailbox, getChineseLength } from '@/utils/hooks/index'
import { phoneRegister, checkAccount } from '@/api/login'
export default {
  props: {
    showRegister: {
      type: Boolean
    },
    isFirstLogin: {
      //是否是第一次登录，设置完就可以置为false
      type: Boolean
    },
    firstLoginCode: {
      type: String
    },
    firstLoginPhone: {
      type: String
    },
    loginScuess: {
      type: Boolean
    }
  },
  data() {
    return {
      isAccept: false, //使用同意用户协议
      errorInfor: '', //错误提示信息
      errType: 0, //0代表没错误 1用户名已存在 手机号错误 两次密码不一致 验证码
      submitInfor: {
        name: '',
        email: '',
        password: '',
        rePassword: ''
      },
      pwd: '', //显示的星星
      rePwd: '', //确认密码显示的星星
      nameErrorInfor: '',
      emailErrorInfor: '',
      passwordErrorInfor: '',
      rePasswordErrorInfor: ''
    }
  },
  methods: {
    pasteRePassword() {
      this.rePwd = ''
      this.submitInfor.rePassword = ''
    },
    pastePassword() {
      this.pwd = ''
      this.submitInfor.password = ''
    },
    //正则校验
    //校验确认代码
    validateConfirmPass(value, same) {
      let reg = /^[\S]*$/
      let reg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-zA-Z]|[0-9]){6,20}$/
      if (!value) {
        return '请输入确认密码'
      } else if (!reg.test(value)) {
        return '密码不允许存在空格'
      } else if (!reg2.test(value)) {
        return '请设置6-20位字母/数字/符号两种以上的组合密码'
      } else if (value !== this.submitInfor.password && same) {
        return '确认密码不一致'
      } else {
        return ''
      }
    },
    //校验第一次输入的代码
    validatePass(value) {
      let reg = /^[\S]*$/
      let reg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-zA-Z]|[0-9]){6,20}$/
      if (!value) {
        return '请输入密码'
      } else if (!reg.test(value)) {
        return '密码不允许存在空格'
      } else if (!reg2.test(value)) {
        return '请设置6-20位字母/数字/符号两种以上的组合密码'
      } else {
        return ''
      }
    },
    //校验用户名
    async validateAccount(value) {
      if (!value) {
        this.nameErrorInfor = '请输入用户名'
      } else if (value.length > 20 || value.length < 5) {
        this.nameErrorInfor = '用户名限制5-20个字符'
      } else {
        //此处需要校验用户是否存在
        await this.checkSame(value, 'userName', 'nameErrorInfor')
        //return ''
      }
    },
    async validateEmail(value) {
      if (!value) {
        this.emailErrorInfor = '请输入邮箱'
      } else if (!verifyMailbox(value)) {
        this.emailErrorInfor = '邮箱格式不正确'
      } else {
        //此处需要校验邮箱是否存在
        await this.checkSame(value, 'email', 'emailErrorInfor')
        //return ''
      }
    },
    async blurEvent(type, same = false) {
      this.submitInfor[type] = this.submitInfor[type].replace(/\s+/g, '')
      switch (type) {
        case 'name':
          //校验名字
          await this.validateAccount(this.submitInfor[type])
          break
        case 'email':
          //检验邮箱
          await this.validateEmail(this.submitInfor[type])
          break
        case 'password':
          this.passwordErrorInfor = this.validatePass(this.submitInfor[type])
          break
        case 'rePassword':
          this.rePasswordErrorInfor = this.validateConfirmPass(this.submitInfor[type], same)
          break
      }
    },
    async toLogin() {
      await this.blurEvent('name')
      await this.blurEvent('email')
      this.blurEvent('password')
      this.blurEvent('rePassword', true)

      if (this.nameErrorInfor == '' && this.emailErrorInfor == '' && this.passwordErrorInfor == '' && this.rePasswordErrorInfor == '') {
        let data = {
          tenantId: '0',
          userName: this.submitInfor.name,
          password: this.submitInfor.password,
          rePassword: this.submitInfor.rePassword,
          phone: this.firstLoginPhone,
          email: this.submitInfor.email,
          verificationCode: this.firstLoginCode
        }
        phoneRegister({ apiVersion: 'v1', data })
          .then(res => {
            if (res.code == 200) {
              let data = res.data
              this.$emit('update:showRegister', false)
              this.$emit('update:isFirstLogin', false)
              //this.$emit('update:showSetInfor', false)
              store.commit('login/setValue', [data.access_token, 'access_token'])
              store.commit('login/setValue', [data.refresh_token, 'refresh_token'])
              store.commit('login/setValue', [data.token_type, 'token_type'])
              store.commit('login/setValue', [true, 'is_login'])
              store.commit('login/setValue', [data, 'userInfor'])
              this.$emit('update:loginScuess', true)
            }
            res.code == 200 ? '' : (this.rePasswordErrorInfor = res.errorMsg)
          })
          .catch(err => {
            this.rePasswordErrorInfor = err.errorMsg
          })
      }
    },
    //唯一性校验
    async checkSame(value, type, errName) {
      await checkAccount({ apiVersion: 'v1', [type]: value })
        .then(res => {
          if (res.code == 200) {
            this[errName] = ''
          }
        })
        .catch(err => {
          this[errName] = err.errorMsg
        })
    }
  },
  // computed: {
  //   //缓存上一次密码
  //   oldPwd() {
  //     return JSON.parse(JSON.stringify(this.pwd))
  //   },
  //   oldRePwd() {
  //     return JSON.parse(JSON.stringify(this.rePwd))
  //   }
  // },
  // watch: {
  //   oldPwd: {
  //     handler(val, oldV) {
  //       //监听登录的密码输入框，将密文显示为*
  //       this.pwd = this.pwd.replace(/./g, '*')
  //       if (oldV.length > val.length) {
  //         //进行删除操作   this.form.password就是定义在data中用来存实际密码的变量
  //         this.submitInfor.password = this.submitInfor.password.substring(0, this.submitInfor.password.length - (oldV.length - val.length))
  //       } else {
  //         this.submitInfor.password += val.replace(/\s+/g, '').replace(/[*]/g, '')
  //       }
  //     },
  //     deep: true
  //   },
  //   oldRePwd: {
  //     handler(val, oldV) {
  //       //监听登录的密码输入框，将密文显示为*
  //       this.rePwd = this.rePwd.replace(/./g, '*')
  //       if (oldV.length > val.length) {
  //         //进行删除操作   this.form.password就是定义在data中用来存实际密码的变量
  //         this.submitInfor.rePassword = this.submitInfor.rePassword.substring(0, this.submitInfor.rePassword.length - (oldV.length - val.length))
  //       } else {
  //         this.submitInfor.rePassword += val.replace(/\s+/g, '').replace(/[*]/g, '')
  //       }
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style lang="less" scoped>
.register-content {
  width: 382px;
  height: 417px;
  background: rgba(11, 25, 66, 0.9);
  border-radius: 8px;
  border: 1px solid #00d2fa;
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 40px 56px 16px;
  box-sizing: border-box;
  transform: translateX(-50%) translateY(-50%);
  .title {
    height: 22px;
    line-height: 22px;
    font-weight: bold;
    color: #ffffff;
    font-size: 14px;
  }
  .top-tip {
    margin-top: 20px;
    color: #82889a;
    line-height: 14px;
    height: 16px;
    font-size: 11px;
  }
  .input-content {
    margin-top: 11px;
    .input-item {
      height: 58px;
      .account {
        width: 100%;
        height: 39px;
        border-radius: 4px;
        border: 1px solid #5b6189;
        display: block;
        background: rgba(11, 25, 66, 0.9);
        color: #ffffff;
        line-height: 39px;
        padding: 10px 16px 9px;
        box-sizing: border-box;
        &:focus {
          outline: none; //这个可以把原来的线去掉
          border: 1px solid #ddd;
        }
        &.error {
          border: 1px solid #ff564d;
        }
        &.codeInput {
          margin-bottom: 0;
        }
      }
      .bottom-tip {
        width: 200%;
        height: 38px;
        line-height: 38px;
        color: #ff564d;
        font-size: 20px;
        transform: scale(0.5);
        position: relative;
        top: -9.5px;
        left: -50%;
      }
    }
  }
  .login {
    height: 39px;
    background: #00d2fa;
    border-radius: 4px;
    line-height: 39px;
    text-align: center;
    font-weight: bold;
    color: #ffffff;
    font-size: 13px;
    cursor: pointer;
    margin-top: 7px;
  }
  .user-infor {
    position: relative;
    padding: 13px 0px 13px 21px;
    box-sizing: border-box;
    .check-box {
      width: 10px;
      height: 10px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #979797;
      position: absolute;
      top: 15px;
      left: 0;
      cursor: pointer;

      &.active {
        background: url('@/assets/image/icon/allScreen.png') no-repeat center;
        background-size: 100%;
        border: none;
      }
    }
    .infor-content {
      p {
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .jg {
    height: 1px;
    background: #82889a;
    opacity: 0.2;
  }
  .toLogin {
    height: 16px;
    line-height: 16px;
    font-size: 11px;
    margin-top: 13px;
    text-align: center;
    font-weight: 400;
    color: #82889a;
  }
  .heightLight {
    color: #82ebff;
    cursor: pointer;
  }
}
</style>
